export const TASKS_REDUCER_KEY = 'tasks';

export class TaskStatus {
  static OPEN = 'OPEN';
  static IN_PROGRESS = 'IN_PROGRESS';
  static DONE = 'DONE';
  static DEFERRED = 'DEFERRED';
}

export class MonitoringTypes {
  static VITALS = "VITALS";
  static BATTERY = "BATTERY";
  static GEOFENCE = "GEOFENCE";
  static SOS = "SOS";
  static ALARMS = "ALARM";
  static TASK = "TASK";
}

export const FILTERS = {
  DONE_TASKS: task => task.status === TaskStatus.DONE,
  OPEN_TASKS: task => task.status === TaskStatus.OPEN,
  IN_PROGRESS_TASKS: task => task.status === TaskStatus.IN_PROGRESS,
  DEFERRED_TASKS: task => task.status === TaskStatus.DEFERRED,
  SYSTEM_CREATED_FILTER: task => task.createdBy === 'SYSTEM',
  UNASSIGNED_FILTER: task => !task.assignedTo,
  SOS_ALARMS_FILTER: task => task.monitoringType === MonitoringTypes.SOS || task.monitoringType === MonitoringTypes.ALARMS,
  VITALS_FILTER: task => task.monitoringType === MonitoringTypes.VITALS,
  GEOFENCE_FILTER: task => task.monitoringType === MonitoringTypes.GEOFENCE
};

export const STATUS_ROW_OBJECT = {
  DONE: {
    titleId: 'tasks.dashboard.done.tasks.title',
    defaultTitle: 'Done',
    color: 'green',
    filter: FILTERS.DONE_TASKS,
  },
  IN_PROGRESS: {
    titleId: 'tasks.dashboard.inprogress.tasks.title',
    defaultTitle: 'In Progress',
    color: 'yellow',
    filter: FILTERS.IN_PROGRESS_TASKS,
  },
  OPEN: {
    titleId: 'tasks.dashboard.open.tasks.title',
    defaultTitle: 'Open',
    color: 'gray',
    filter: FILTERS.OPEN_TASKS,
  },
  DEFERRED: {
    titleId: 'tasks.dashboard.deferred.tasks.title',
    defaultTitle: 'Deferred Tasks',
    color: 'purple',
    filter: FILTERS.DEFERRED_TASKS,
  },
  TASK_GEN: {
    titleId: 'tasks.dashboard.task.gen.title',
    defaultTitle: 'Task Generation (Per Day)',
  },
  TASK_RESOLVED: {
    titleId: 'tasks.dashboard.task.resolve.title',
    defaultTitle: 'Task Resolved (Per Day)',
    color: 'green',
    filter: FILTERS.DONE_TASKS,
  },
  TASK_UNASSIGNED: {
    titleId: 'tasks.dashboard.task.unassigned.title',
    defaultTitle: 'Task Unassigned',
    color: 'purple',
    filter: FILTERS.UNASSIGNED_FILTER,
  },
  SOS: {
    id: "sos",
    titleId: 'tasks.dashboard.sos.tasks.title',
    defaultTitle: 'SOS & Alarms',
    color: 'red',
    filter: FILTERS.SOS_ALARMS_FILTER,
    clickData: {value: MonitoringTypes.SOS, filterKey: 'monitoringType'}
  },
  VITALS: {
    id: "vitals",
    titleId: 'tasks.dashboard.vitals.tasks.title',
    defaultTitle: 'Vitals',
    color: 'yellow',
    filter: FILTERS.VITALS_FILTER,
    clickData: {value: MonitoringTypes.VITALS, filterKey: 'monitoringType'}
  },
  GEOFENCE: {
    id: "geoFence",
    titleId: 'tasks.dashboard.geofence.tasks.title',
    defaultTitle: 'Geo-Fence',
    color: 'blue',
    filter: FILTERS.GEOFENCE_FILTER,
    clickData: {value: MonitoringTypes.GEOFENCE, filterKey: 'monitoringType'}
  },
  DOENTASKS: {
    id: "doneTasks",
    titleId: 'tasks.dashboard.done.tasks.title',
    defaultTitle: 'Done',
    color: 'green',
    filter: FILTERS.DONE_TASKS,
    clickData: {value: "true", filterKey: 'isDone'}
  },
};

export const GROUP_IDS = {
  SUPERVISOR: "groupSupervisor",
  STATUS: "groupStatus",
  NONE: "none"
}

export const GROUPING_MODE = [
  {
    label: 'tasks.list.group.title.status',
    defaultMessage: 'Status',
    value: GROUP_IDS.STATUS
  },
  {
    label: 'tasks.list.group.title.agent',
    defaultMessage: 'Supervisors',
    value: GROUP_IDS.SUPERVISOR
  },
  {
    label: 'tasks.list.group.title.none',
    defaultMessage: 'None',
    value: GROUP_IDS.NONE
  },
];

export const handleTaskModification = (task) => {
  try {
    task.createdAt = new Date(task.createdAt).getTime();
    task.updatedAt = new Date(task.createdAt).getTime();
    task.isUnAssigned = !(task.assignedTo && task.assigneeName);
    task.isDone = (task.status === "DONE") + ""
  } catch (e) {}
}

export const INTERVAL_OPTIONS = [
  {value: 0, label: "1 Day"},
  {value: 3, label: "3 Days"},
  {value: 7, label: "7 Days"},
  {value: 14, label: "14 Days"}
];

export const TASK_STATUS_DD_VALUES = [TaskStatus.OPEN, TaskStatus.IN_PROGRESS, TaskStatus.DONE, TaskStatus.DEFERRED].map(status => ({value: status, label: status}));

export const MONITORING_TYPE_DD_VALUES = [MonitoringTypes.SOS, MonitoringTypes.ALARMS, MonitoringTypes.GEOFENCE, MonitoringTypes.VITALS].map(status => ({value: status, label: status}));

export const getStatusRowObject = (configObj, listOfItems) => ({
  ...configObj,
  count: (listOfItems || []).filter(configObj.filter).length
})
